(() => {
  const init = root => {
    if (root.dataset.digestReady) return;
    const slide = root.closest('.slideshow__slide');
    const slider = root.closest('.hero');
    const video = root.querySelector('video');
    if (!slide || !slider || !video || !window.jQuery) return;
    root.dataset.digestReady = 'true';
    const $slider = window.jQuery(slider);
    const fallback = root.querySelector('[data-digest-play]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const options = {signal: controller.signal};
    const pauseButton = slider.closest('.slideshow-wrapper').querySelector('.slideshow__pause');
    let timeout, pending = false, finished = false, generation = 0;
    const selected = () => slide.classList.contains('slick-active');
    const visible = () => {
      const rect = root.getBoundingClientRect();
      return !document.hidden && rect.bottom > 0 && rect.top < innerHeight;
    };
    const userPaused = () => pauseButton?.classList.contains('is-paused');
    const pauseSlider = () => {
      if ($slider.hasClass('slick-initialized')) $slider.slick('slickPause');
    };
    const resumeSlider = () => {
      if (!userPaused() && slider.dataset.autoplay === 'true' && $slider.hasClass('slick-initialized')) $slider.slick('slickPlay');
    };
    const play = async (manual = false) => {
      if (!selected() || !visible() || pending || (!manual && userPaused())) return;
      if (reduced.matches && !manual) { fallback.hidden = false; return; }
      pauseSlider();
      if (finished || video.ended) { video.currentTime = 0; finished = false; }
      video.muted = true;
      video.defaultMuted = true;
      pending = true;
      const attempt = ++generation;
      try {
        await video.play();
        if (attempt !== generation || !selected() || !visible()) { video.pause(); return; }
        fallback.hidden = true;
        root.classList.add('is-playing');
      } catch {
        if (attempt === generation && selected()) { fallback.hidden = false; resumeSlider(); }
      } finally { if (attempt === generation) pending = false; }
    };
    const deactivate = () => {
      ++generation;
      pending = false;
      clearTimeout(timeout);
      video.pause();
      root.classList.remove('is-playing');
    };
    const activate = () => {
      if (!selected()) return;
      clearTimeout(timeout);
      video.currentTime = 0;
      finished = false;
      play();
    };
    video.addEventListener('ended', () => {
      if (!selected()) return;
      finished = true;
      timeout = setTimeout(() => {
        if (selected() && !userPaused() && !window.Shopify?.designMode) {
          $slider.slick('slickNext');
          resumeSlider();
        }
      }, 1200);
    }, options);
    video.addEventListener('error', resumeSlider, options);
    fallback.addEventListener('click', () => play(true), options);
    pauseButton?.addEventListener('click', () => {
      queueMicrotask(() => {
        if (!selected()) return;
        if (userPaused()) deactivate();
        else play();
      });
    }, options);
    $slider.on('beforeChange.hqDigest', () => { deactivate(); resumeSlider(); });
    $slider.on('afterChange.hqDigest', activate);
    $slider.on('init.hqDigest reInit.hqDigest', () => queueMicrotask(activate));
    $slider.on('destroy.hqDigest', deactivate);
    const visibility = () => {
      if (!selected()) return;
      if (visible()) play();
      else deactivate();
    };
    document.addEventListener('visibilitychange', visibility, options);
    const observer = new IntersectionObserver(visibility);
    observer.observe(root);
    const focusPreview = () => {
      if (new URLSearchParams(location.search).get('hq_video_preview') === '1' && $slider.hasClass('slick-initialized')) {
        $slider.slick('slickGoTo', Number(slide.dataset.slickIndex));
      }
      activate();
    };
    if ($slider.hasClass('slick-initialized')) focusPreview();
    else $slider.one('init.hqDigestPreview', () => queueMicrotask(focusPreview));
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      deactivate();
      observer.disconnect();
      controller.abort();
      $slider.off('.hqDigest').off('.hqDigestPreview');
    }, options);
  };
  const boot = () => document.querySelectorAll('[data-hq-digest]').forEach(init);
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot, {once:true});
  window.addEventListener('load', boot, {once:true});
  document.addEventListener('shopify:section:load', boot);
})();
